"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const react_1 = require("react");
const hui_1 = require("@mit/hui");
const ContactTracingApi_1 = __importDefault(require("../../api/ContactTracingApi"));
const Formatters_1 = require("../../common/Formatters");
const ContactAudit = ({ mitId }) => {
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [unAuth, setUnAuth] = (0, react_1.useState)(false);
    const [isError, setError] = (0, react_1.useState)(false);
    const [audits, setAudits] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        fetchComments();
    }, []);
    const fetchComments = () => {
        setLoading(true);
        ContactTracingApi_1.default.fetchAudit(mitId).then((response) => {
            if (response.error) {
            }
            else if (response.unauth) {
                setUnAuth(true);
            }
            else {
                if (response.items) {
                    setLoading(false);
                    setAudits(response.items);
                }
            }
        });
    };
    const getAuditTypeIcon = (audit_type) => {
        if (audit_type === "comment")
            return (0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "regular", icon: "comments" });
        if (audit_type === "tested_positive")
            return (0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "regular", icon: "microscope" });
        if (audit_type === "tested_negative")
            return (0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "regular", icon: "microscope" });
        if (audit_type === "medical_symptoms")
            return (0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "regular", icon: "briefcase-medical" });
        if (audit_type === "hold")
            return (0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "regular", icon: "briefcase-medical" });
        if (audit_type === "flu_shot")
            return (0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "regular", icon: "syringe" });
        if (audit_type === "attestation_all_cleared")
            return (0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "regular", icon: "clipboard-list-check" });
        if (audit_type === "attestation_has_symptoms")
            return (0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "regular", icon: "clipboard-list-check" });
    };
    if (isError)
        return (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, message: "Oops.. something went wrong", type: hui_1.ErrorType.Generic });
    if (unAuth)
        return (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, message: "Not Authorized", type: hui_1.ErrorType.AccessDenied });
    return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [isLoading && (0, jsx_runtime_1.jsx)(hui_1.ActionList, { isLoading: true, items: [] }), !isLoading && ((0, jsx_runtime_1.jsx)(React.Fragment, { children: audits.map((itm, i) => {
                    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `row ${itm.audit_type}` }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-3" }, { children: (0, Formatters_1.displayDateTimeShort)(itm.datetime) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-1" }, { children: getAuditTypeIcon(itm.audit_type) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "col-8" }, { children: [(0, jsx_runtime_1.jsx)("div", { children: itm.title }), (0, jsx_runtime_1.jsx)("div", { children: itm.description_line1 }), (0, jsx_runtime_1.jsx)("div", { children: itm.description_line2 })] }))] })), (0, jsx_runtime_1.jsx)("hr", {})] }, `audit_item_${i}`));
                }) }))] }));
};
exports.default = ContactAudit;
